var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showBox,
      expression: "showBox"
    }],
    staticClass: "Layer-FullScreen noticeType-Bulletbox component-reward-tool-box",
    class: {
      'show-animation': _vm.showBox,
      'fade-out': _vm.showOutAnimation
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hideBox.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "main-border act-tool-box"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('ycf-svg', {
    staticClass: "iconfont all_new_close_icon",
    attrs: {
      "icon-name": "all_new_close_icon"
    },
    on: {
      "click": _vm.hideBox
    }
  }), _c('p', {
    staticClass: "title"
  }, [_vm._v("出单奖励大赛")]), _c('p', {
    staticClass: "desc"
  }, [_vm._v("该产品正在参加出单奖励活动，现在推广可拿奖金大奖，赶快行动吧！")]), _c('button', {
    on: {
      "click": _vm.goTaskDetailsPage
    }
  }, [_vm._v("去领取")])], 1)]), _c('ycf-image', {
    staticClass: "left-top",
    attrs: {
      "src": require("@/assets/img/l-t-icon.png")
    }
  }), _c('ycf-image', {
    staticClass: "right-bottom",
    attrs: {
      "src": require("@/assets/img/r-b-icon.png")
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };